import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/auth.models';
import { StorageService } from './storage.service';
import { FirebaseService } from './firebase.service';

const USER_KEY = 'currentUser';
const SERVICE_PROVIDER_SELECTED_KEY = 'serviceProviderIdSelected';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
  private currentUserSubject: BehaviorSubject<User | null>;
  public currentUser: Observable<User | null>;

  constructor(
    private storage: StorageService,
    private firebaseService: FirebaseService,
  ) {
    this.currentUserSubject = new BehaviorSubject<User | null>(
      this.storage.get<User>(USER_KEY),
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  public getUser(): any {
    return this.storage.get(USER_KEY);
  }

  login(user: any): any {
    const content = { ...user };
    content.token = user.jwtToken?.token;

    if (content && content.token) {
      this.storage.set(USER_KEY, content);
      this.currentUserSubject.next(content);
    }
    return content;
  }

  updateUserLanguage(user: User): void {
    const currentUser = this.getUser();
    if (!currentUser) return;
    currentUser.language = user.language;

    this.storage.set(USER_KEY, currentUser);
    this.currentUserSubject.next(currentUser);
  }

  logout(): void {
    this.storage.remove(USER_KEY);
    // Limpa o prestador selecionado para não vazar entre sessões/usuários.
    // Cobre o logout por expiração (401) disparado pelo ErrorInterceptor.
    localStorage.removeItem(SERVICE_PROVIDER_SELECTED_KEY);
    this.firebaseService.clearAndDestroy();
    this.currentUserSubject.next(null);
  }
}
